import { NgModule } from '@angular/core';
import { CommonModule }  from '@angular/common';
import { HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { MdlModule } from '@angular-mdl/core';

import { TranslateModule } from '../../../translate/translate.module';

import { PaymentMenuComponent } from './payment-menu.component';

@NgModule({
  imports: [
    CommonModule,
    HttpModule,
    FormsModule,
    TranslateModule,
    MdlModule
  ],
  declarations: [
    PaymentMenuComponent
  ],
  exports: [PaymentMenuComponent]
})
export class PaymentMenuModule { }
